import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { TabPanelProps } from './Tabs.props';

export const TabPanel = React.memo(
  ({
    children,
    value,
    activeValue,
    keepMounted = false,
    ...props
  }: TabPanelProps) => {
    const isActive = value === activeValue;

    const sxStyles = useMemo(
      () => ({
        flex: 1,
        display: isActive ? 'flex' : 'none',
        overflow: 'auto',
        ...props.sx,
      }),
      [isActive, props.sx]
    );

    // Only render if active or keepMounted is true
    if (!isActive && !keepMounted) {
      return null;
    }

    return (
      <Box
        role="tabpanel"
        hidden={!isActive}
        id={`tabpanel-${value}`}
        aria-labelledby={`tab-${value}`}
        {...props}
        sx={sxStyles}
      >
        {children}
      </Box>
    );
  }
);

TabPanel.displayName = 'TabPanel';

export default TabPanel;
